import React from "react";
import { Ptag } from "components/core";
import { DividerLine, PageTitleWrapper } from "./styles";

function PageTitle({ title }) {
  return (
    <PageTitleWrapper>
      <Ptag fontFamily="Merriweather" fontWeight="600" fontSize="24px">
        {title}
      </Ptag>
      <DividerLine />
    </PageTitleWrapper>
  );
}

export default PageTitle;
